module.exports = __webpack_public_path__ + "img/IMG_8930.3b66a017.jpg";